import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const file = (state = initialState.file, action) => {
  switch (action.type) {
    case types.UPLOAD_FILE_SUCCESS:
      return action.file;

    default:
      return state;
  }
};
